export const MONTHS_TO_DISPLAY = 2;
